import { useState, useEffect } from "react";
import { X } from "@phosphor-icons/react";

export function Modal({ open, onClose, title, children, testId }) {
  useEffect(() => {
    const h = (e) => e.key === "Escape" && onClose();
    if (open) document.addEventListener("keydown", h);
    return () => document.removeEventListener("keydown", h);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/40 backdrop-blur-sm fade-in"
      onClick={onClose} data-testid={testId}>
      <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col"
        onClick={(e) => e.stopPropagation()}>
        <div className="h-14 border-b border-slate-200 flex items-center justify-between px-5">
          <h3 className="font-bold text-slate-900" style={{ fontFamily: "Chivo" }}>{title}</h3>
          <button onClick={onClose} className="w-8 h-8 rounded flex items-center justify-center hover:bg-slate-100"
            data-testid="modal-close">
            <X size={18} />
          </button>
        </div>
        <div className="p-6 overflow-y-auto flex-1">{children}</div>
      </div>
    </div>
  );
}

export function PageHeader({ eyebrow, title, actions }) {
  return (
    <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-8 sticky top-0 z-30">
      <div>
        <div className="eyebrow">{eyebrow}</div>
        <h1 className="text-lg font-bold text-slate-900" style={{ fontFamily: "Chivo" }}>{title}</h1>
      </div>
      <div className="flex items-center gap-2">{actions}</div>
    </header>
  );
}

export function Btn({ children, variant = "primary", className = "", ...p }) {
  const base = "inline-flex items-center gap-2 h-10 px-4 rounded-md text-sm font-medium transition-colors disabled:opacity-50";
  const styles = {
    primary: "bg-slate-900 text-white hover:bg-slate-800",
    secondary: "bg-white border border-slate-300 text-slate-900 hover:bg-slate-50",
    danger: "bg-red-600 text-white hover:bg-red-700",
    ghost: "text-slate-700 hover:bg-slate-100",
    accent: "bg-blue-600 text-white hover:bg-blue-700",
  };
  return <button className={`${base} ${styles[variant]} ${className}`} {...p}>{children}</button>;
}

export function Field({ label, children }) {
  return (
    <label className="block">
      <span className="eyebrow block mb-1.5">{label}</span>
      {children}
    </label>
  );
}

export function Input(props) {
  return <input {...props}
    className={"w-full h-10 rounded-md border border-slate-300 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 focus:border-transparent " + (props.className || "")} />;
}

export function Select({ children, ...p }) {
  return <select {...p}
    className={"w-full h-10 rounded-md border border-slate-300 px-3 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-slate-900 " + (p.className || "")}>
    {children}
  </select>;
}

export function Textarea(props) {
  return <textarea {...props}
    className={"w-full rounded-md border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 " + (props.className || "")} />;
}

export function Badge({ tone = "slate", children }) {
  const tones = {
    slate: "bg-slate-100 text-slate-700",
    blue: "bg-blue-100 text-blue-700",
    green: "bg-emerald-100 text-emerald-700",
    amber: "bg-amber-100 text-amber-700",
    red: "bg-red-100 text-red-700",
  };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium ${tones[tone]}`}>{children}</span>;
}
